import React, { Component } from 'react'
import { Button } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'

import Router from '../../costra/Router.js'
import Dialogs from '../../costra/Dialogs.js'
import Translate from '../../costra/Translate.js'
import SimpleListContainer from '../../costra/SimpleListContainer.js'

import TableHeader from '../../utils/TableHeader.js'
import Table from '../../utils/Table.js'
import ErrorPlaceholder from '../../utils/ErrorPlaceholder.js'
import LoadingPlaceholder from '../../utils/LoadingPlaceholder.js'
import SearchContainer from '../../utils/SearchContainer.js'

import RemoveCalendarDialog from './RemoveCalendarDialog.js'

import '../../css/list.css'

const columns = [
  {
    title: () => Translate.get('table.name'),
    dataIndex: 'name',
    key: 'name',
    render: (text, record) => <Button type="link" style={{ fontWeight: 'bold', padding: 0 }} onClick={() => Router.go('/calendars/' + record.key)}>{text}</Button>
  },
  {
    title: '',
    key: 'action',
    fixed: 'right',
    width: 100,
    align: 'right',
    render: (_, record) => (
      <Button 
        icon={<DeleteOutlined />} 
        title={Translate.get('delete.button')} 
        onClick={() => Dialogs.open(<RemoveCalendarDialog item={record} />)}
      />
    ),
  }
]

class Calendars extends Component {

  constructor(props) {
    super(props)
    var state = SimpleListContainer.initialState()
    state.itemsPerPage = 50
    state.searchedText = ''
    this.state = state
    this.container = new SearchContainer(this, 'com.optimsys.costra.optimcall.shiftplanner.calendar.Calendars', () => {
      this.setState({ error: 'error.load.calendars' })
    })
  }

  componentDidMount() {
    this.container.reload()
  }

  componentWillUnmount() {
    this.container.close()
  }

  render() {
    if (this.state.error) {
      return <ErrorPlaceholder error={this.state.error} />
    }
    if (!this.state.items) {
      return <LoadingPlaceholder />
    }

    const data = this.state.items.map(item => {
      return {
        key: item._id.$oid,
        name: item.displayName || Translate.get('entity.unnamed'),
      }
    })

    return <div className="content-column">
      <TableHeader
        icon="calendar"
        title="calendar.section"
        noTenant={this.state.noTenant}
        allowAdd={this.state.allowAdd}
        addPath="/calendars/new"
        addTitle="calendar.create.button"
      />

      <Table
        component={this}
        container={this.container}
        columns={columns}
        data={data}
      />
    </div>
  }
}

export default Calendars